import { State } from "./state";
import { GetterTree } from "vuex";

import { getError, getIsLoading, getDataItem, getSuccess, getDataList, getTotal, getId } from "@/store/Crud/functions/getters";

export const getTheoryQuestion = (state: State) => state.theoryQuestion;
export const getWrongAnswer = (state: State) => state.wrongAnswer;

export default <GetterTree<State, any>>{
  getError,
  getIsLoading,
  getDataItem,
  getSuccess,
  getDataList,
  getTotal,
  getId,
  getTheoryQuestion,
  getWrongAnswer,
};
